module.exports = __webpack_public_path__ + "static/media/handshake_white.eb2a3ea0.png";